import { Box, Typography } from '@mui/material';
import CustomSectionWrapper from '@/DesignSystem/wrappers/CustomSectionWrapper';
import CustomImageComponent from '@/components/shared/custom/custom-image';
import SocialNetworkLinks from '@/components/shared/social-networks/SocialNetworkLinks';

const NoticiaFlashAuthor = ({ account, author }) => {
    if (!account?.nickname && !author) {
        return null;
    }

    return (
        <CustomSectionWrapper mb={2}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                {account?.image ? (
                    <>
                        <CustomImageComponent
                            src={account.image}
                            alt={account.nickname}
                            width={60}
                            height={60}
                            style={{ borderRadius: '50%' }}
                        />
                        <Box sx={{ flex: 1 }}>
                            <Typography sx={{ fontSize: '14px', fontWeight: 600, mb: 0.5 }}>
                                Creador por: {account.nickname}
                            </Typography>
                            <SocialNetworkLinks userSocial={account.userSocial} />
                        </Box>
                    </>
                ) : (
                    <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>Autor: {author}</Typography>
                )}
            </Box>
        </CustomSectionWrapper>
    );
};

export default NoticiaFlashAuthor;
